import React from 'react';
import { useInView } from './useInView';
import './Projects.css';

const projects = [
  {
    title: 'Smart Expense Tracker & Budget Planner',
    desc: 'A full-stack finance management system with secure JWT authentication, RESTful endpoints, and interactive dashboards to visualize expense trends and category-based insights.',
    stack: ['Java', 'Spring Boot', 'React.js', 'MySQL'],
    highlights: ['JWT Auth', 'Layered Architecture', 'DB Indexing', 'Analytics Dashboard'],
    featured: true,
    emoji: '💰'
  },
  {
    title: 'Apple Website Clone',
    desc: 'A scalable product catalog backend built with Spring Boot, integrated with a React frontend using clean architecture and reusable component structure.',
    stack: ['Java 17', 'Spring Boot', 'React.js'],
    highlights: ['REST APIs', 'Clean Architecture', 'Product Catalog'],
    featured: false,
    emoji: '🍎'
  }
];

export default function Projects() {
  const [ref, visible] = useInView();

  return (
    <section className="section" id="projects">
      <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
        <p className="section-label">Projects</p>
        <h2 className="section-title">Things I've built.</h2>
        <div className="projects-grid">
          {projects.map((p, i) => (
            <div key={i} className={`project-card${p.featured ? ' featured' : ''}`} style={{ animationDelay: `${i * 0.15}s` }}>
              {p.featured && <div className="featured-tag">Featured Project</div>}
              <div className="project-emoji">{p.emoji}</div>
              <h3 className="project-title">{p.title}</h3>
              <p className="project-desc">{p.desc}</p>
              <div className="project-highlights">
                {p.highlights.map(h => <span key={h} className="highlight">{h}</span>)}
              </div>
              <div className="project-stack">
                {p.stack.map(s => <span key={s} className="stack-tag">{s}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
